module.exports = __webpack_public_path__ + "static/media/animal.0f99fcc1.svg";